import Swiper from 'swiper/bundle';
import { updateOpacity } from './utils';

export default function initSwiperVideos(playersInstance) {
    const swiperVideosContainer = document.querySelector(".swiperVideos");

    if (swiperVideosContainer) {
        playersInstance.swiperVideos = new Swiper(".swiperVideos", {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },
            navigation: {
                nextEl: ".block-swiper-videos .swiper-next",
                prevEl: ".block-swiper-videos .swiper-prev",
            },
            on: {
                slideChange: () => {
                    playersInstance.pauseCurrentVideo();
                    playersInstance.removePlayingClass();
                    updateOpacity(playersInstance.swiperVideos);
                },
                beforeChange: () => {
                    playersInstance.pauseCurrentVideo();
                    playersInstance.removePlayingClass();
                    updateOpacity(playersInstance.swiperVideos);
                },
                init: () => {
                    setTimeout(() => {
                        updateOpacity(playersInstance.swiperVideos);
                    }, 100);
                }
            },
        });
    }
}
